/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_AgainInputs */

const en_import_again = /** @type {(inputs: Import_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import again`)
};

const de_import_again = /** @type {(inputs: Import_AgainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trotzdem importieren`)
};

/**
* | output |
* | --- |
* | "Import again" |
*
* @param {Import_AgainInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_again = /** @type {((inputs?: Import_AgainInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_AgainInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_again(inputs)
	return en_import_again(inputs)
});